import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-140 -70 280 140", fill: "#f8e92e", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#d82126", d: "M-140-70h280V70h-280z" }), /* @__PURE__ */ React.createElement("path", { d: "M-140 14v-28l280 28v-28zm126-84h28L0-15zM14 70h-28L0 15zM-140-70h42L12.86 7.72zm0 140h42L12.86-7.72zM140-70H98L-12.86 7.72zm0 140H98L-12.86-7.72z" }), /* @__PURE__ */ React.createElement("circle", { r: 25, fill: "#d82126" }), /* @__PURE__ */ React.createElement("circle", { r: 20 }));
const ForwardRef = forwardRef(SvgMk);
const Memo = memo(ForwardRef);
export default Memo;
